
        import * as module0 from './controllers/example_controller.js';import * as module1 from './controllers/navigation_controller.js';import * as module2 from './controllers/page_height_controller.js'
        const modules = {
            "./controllers/example_controller.js": module0,
            "./controllers/navigation_controller.js": module1,
            "./controllers/page_height_controller.js": module2,
        };
        export default modules;
      